import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { Check } from 'lucide-react';
export function FinalPurchaseSection() {
  return <section className="py-8 md:py-14 px-4 bg-white border-t-2 border-gray-200" data-id="element-62">
      <div className="max-w-3xl mx-auto" data-id="element-63">
        <div className="text-center mb-6 md:mb-8" data-id="element-64">
          <div className="inline-block bg-brand-danger text-white font-black px-4 py-1.5 rounded-full mb-4 shadow-md uppercase tracking-wider animate-pulse text-xs" data-id="element-65">
            ⚠️ ÚLTIMA LLAMADA — TERMINA EN:
          </div>

          <div className="mb-5" data-id="element-66">
            <CountdownTimer data-id="element-67" />
          </div>

          <h2 className="text-lg md:text-2xl font-black text-center text-brand-text uppercase" data-id="element-68">
            ESTO ES TODO LO QUE RECIBES HOY:
          </h2>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-69">
          <div className="bg-white rounded-2xl border-4 border-brand-primary p-5 md:p-7 flex flex-col relative shadow-[0_15px_30px_rgba(0,102,255,0.15)]" data-id="element-70">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-secondary text-brand-text font-black px-4 py-1 rounded-full text-[11px] md:text-xs tracking-widest shadow-md whitespace-nowrap uppercase border-2 border-white" data-id="element-71">
              ⭐ LA OPCIÓN MÁS ELEGIDA ⭐
            </div>

            <div className="mb-5 mt-2 text-center" data-id="element-72">
              <h3 className="text-lg md:text-xl font-black text-brand-primary mb-1 uppercase" data-id="element-73">
                MASTER ELECTROTÉCNICO
              </h3>
              <p className="text-[11px] md:text-xs text-brand-steel font-bold uppercase tracking-wide" data-id="element-74">
                Producto principal + 3 Bonos GRATIS
              </p>
              <div className="w-14 h-1 bg-brand-secondary mx-auto mt-2.5" data-id="element-75"></div>
            </div>

            <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-76">
              <li className="flex items-start" data-id="element-77">
                <Check className="w-5 h-5 text-brand-primary mr-2.5 shrink-0 mt-0.5" data-id="element-78" />
                <span className="font-bold text-brand-text text-xs md:text-sm" data-id="element-79">
                  📘 EL SISTEMA DEFINITIVO: MASTER ELECTROTÉCNICO
                </span>
              </li>
              <li className="flex items-start" data-id="element-80">
                <Check className="w-5 h-5 text-brand-secondary mr-2.5 shrink-0 mt-0.5" data-id="element-81" />
                <span className="font-bold text-brand-text text-xs md:text-sm" data-id="element-82">
                  🎁 BONO 1: Guía PLC{' '}
                  <span className="text-brand-danger" data-id="element-83">(GRATIS)</span>
                </span>
              </li>
              <li className="flex items-start" data-id="element-84">
                <Check className="w-5 h-5 text-brand-secondary mr-2.5 shrink-0 mt-0.5" data-id="element-85" />
                <span className="font-bold text-brand-text text-xs md:text-sm" data-id="element-86">
                  🎁 BONO 2: Manual Domiciliario{' '}
                  <span className="text-brand-danger" data-id="element-87">(GRATIS)</span>
                </span>
              </li>
              <li className="flex items-start" data-id="element-88">
                <Check className="w-5 h-5 text-brand-secondary mr-2.5 shrink-0 mt-0.5" data-id="element-89" />
                <span className="font-bold text-brand-text text-xs md:text-sm" data-id="element-90">
                  🎁 BONO 3: Manual Tablerista{' '}
                  <span className="text-brand-danger" data-id="element-91">(GRATIS)</span>
                </span>
              </li>
            </ul>

            <div className="mb-5 text-center bg-blue-50 py-3 rounded-xl border border-blue-200" data-id="element-92">
              <p className="text-[11px] md:text-xs text-brand-primary font-bold uppercase tracking-wider mb-0.5" data-id="element-93">
                Precio Especial Hoy
              </p>
              <div className="flex items-end justify-center" data-id="element-94">
                <span className="text-3xl md:text-4xl font-black text-brand-primary" data-id="element-95">
                  $19.90{' '}
                  <span className="text-base text-brand-primaryDark font-bold" data-id="element-96">
                    USD
                  </span>
                </span>
              </div>
            </div>

            <Button href="https://a3dm10-h0.myshopify.com/cart/44781499973767:1" className="py-3 md:py-4 text-base md:text-lg" pulse={true} data-id="element-97">
              ¡SÍ! QUIERO EL MASTER ELECTROTÉCNICO
            </Button>

            <p className="text-[10px] md:text-xs text-center text-brand-steel mt-3 font-medium leading-snug" data-id="element-98">
              🌐 Pago Seguro y Moneda Local: Al hacer clic, verás el precio
              convertido automáticamente a tu moneda local. 🔒 Pago 100%
              Protegido.
            </p>
          </div>
        </div>
      </div>
    </section>;
}